import {Subject, Subscription} from './Subject'

export class BehaviorSubject<T> extends Subject<T> {
  public value: T

  constructor(initialValue: T) {
    super()
    this.value = initialValue
  }

  subscribe(listener: (value: T) => void): Subscription {
    listener(this.value)
    return super.subscribe(listener)
  }

  next(value: T) {
    this.value = value
    super.next(value)
  }
}
